import React, {useState, useEffect, useRef} from 'react';
import "./Dropdown.css";

const Dropdown = ({options, selectedOption = "", setSelectedOption}) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('click', handleOutsideClick);
        return () => document.removeEventListener('click', handleOutsideClick);
    }, []);

    return (
        <div className="dropdown" ref={dropdownRef}>
            <div 
                className="dropdown-toggle" 
                onClick={() => setShowDropdown(!showDropdown)}
            >
                {selectedOption}
            </div>
            {showDropdown && (
                <div className="dropdown-menu">
                    {options.map((option, index) => (
                        <div key={index} onClick={() => setSelectedOption(option)}>{option}</div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default Dropdown;